<header-web (dataEvent)='setLanguage($event)' [restaurante]='true'></header-web>
<!-- <div class="w-100 px-0 margen-h">
  <div class="row d-flex align-items-stretch">
    <div class="col-6 p-0">
      <div class="aurora">
        <div class="aurora-one"></div>
        <div class="aurora-two"></div>
        <div class="aurora-three"></div>
        <h3 class="aurora-text text-white text-center">SOFTWARE RESTAURANTES</h3>
        <p class="text-white subtitle-1 mt-2 px-4 text-center lh-sm">Administra totalmente tu hotel y facturación de
          una manera sencillo con el software <strong>GALILEO-ERP</strong></p>
      </div>
    </div>
    <div class="col-6 p-0" style="z-index: 0;">
      <div id="carrousel-r" class="carousel slide carousel-fade" data-bs-ride="carousel">
        <div class="carousel-inner">
          <div class="carousel-item active">
            <img src="../../assets/image/galeria/Yachay.jpg" class="d-block w-100" alt="...">
          </div>
          <div class="carousel-item">
            <img src="../../assets/image/galeria/Yachay.jpg" class="d-block w-100" alt="...">
          </div>
          <div class="carousel-item">
            <img src="../../assets/image/galeria/Yachay.jpg" class="d-block w-100" alt="...">
          </div>
        </div>
        <button class="carousel-control-prev" type="button" data-bs-target="#carrousel-r" data-bs-slide="prev">
          <span class="carousel-control-prev-icon" aria-hidden="true"></span>
          <span class="visually-hidden">Previous</span>
        </button>
        <button class="carousel-control-next" type="button" data-bs-target="#carrousel-r" data-bs-slide="next">
          <span class="carousel-control-next-icon" aria-hidden="true"></span>
          <span class="visually-hidden">Next</span>
        </button>
      </div>
    </div>
  </div>
</div> -->
<div class="w-100 px-0 margen-h">
  <div class="row mx-0 d-flex align-items-stretch">
    <div class="col-md-6 col-12 p-0 d-none d-md-block p-0" style="position: relative;">
      <section class="panel-bg bg-dark">
        <h1 class="title">SOFTWARE RESTAURANTES</h1>
        <!-- <h3 class="">Administra totalmente tu hotel y facturación de una manera sencillo con el software</h3> -->
        <h3 class="span loader subtitle"><span class="m">A</span><span class="m">D</span><span class="m">M</span><span
            class="m">I</span><span class="m">S</span><span class="m">T</span><span class="m">R</span><span
            class="m">A</span><span class="m">&nbsp;</span><span class="m">T</span><span class="m">U</span><span
            class="m">&nbsp;</span><span class="m">R</span><span class="m">E</span><span class="m">S</span><span
            class="m">T</span><span class="m">A</span><span class="m">U</span><span class="m">R</span><span
            class="m">A</span><span class="m">N</span><span class="m">T</span><span class="m">E</span></h3>
      </section>
      <canvas class="lineas"></canvas>
    </div>
    <div class="col-md-6 col-12 p-0" style="z-index: 0;">
      <div id="carouselExampleFade" class="carousel slide carousel-fade" data-bs-ride="carousel">
        <div class="carousel-inner">
          <div class="carousel-item active">
            <img src="../../assets/image/galeria/Restaurante.jpg" class="d-none d-md-block w-100" alt="...">
            <img src="../../assets/image/carrousel/movil-2.jpg" class="d-block d-md-none w-100" alt="...">
          </div>
          <div class="carousel-item">
            <img src="../../assets/image/galeria/Restaurante-2.jpg" class="d-none d-md-block w-100" alt="...">
            <img src="../../assets/image/carrousel/restaurante-movil-1.png" class="d-block d-md-none w-100" alt="...">
          </div>
          <div class="carousel-item">
            <img src="../../assets/image/galeria/Restaurante-3.jpg" class="d-none d-md-block w-100" alt="...">
            <img src="../../assets/image/carrousel/restaurante-movil-2.png" class="d-block d-md-none w-100" alt="...">
          </div>
        </div>
        <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleFade" data-bs-slide="prev">
          <span class="carousel-control-prev-icon" aria-hidden="true"></span>
          <span class="visually-hidden">Previous</span>
        </button>
        <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleFade" data-bs-slide="next">
          <span class="carousel-control-next-icon" aria-hidden="true"></span>
          <span class="visually-hidden">Next</span>
        </button>
      </div>
    </div>
  </div>
</div>
<section class="container text-center my-5 px-md-5 px-1">
  <h2 class="color-1 title fw-bold text-rojo">FÁCIL Y MUY INTUITIVO</h2>
  <div class="row mx-0">
    <div class="col-md-8 offset-md-2 col-12">
      <div class="container">
        <p class="subtitle mt-2 mb-0 fw-bold text-justify">Este moderno software para restaurantes propone una solución
          global, escalable y adaptada a tu negocio. Galileo-ERP cubre todas las necesidades del restaurante, mejora la
          eficiencia, optimiza los recursos e incrementa los beneficios de la empresa.</p>
        <!-- <button class="btn-demo subtitle mt-3" role="button"><strong class="fw-bold">Solicitar Información</strong></button> -->
      </div>
    </div>
  </div>
</section>
<section class="container-fluid px-md-5 px-1">
  <div class="row mx-0 d-flex align-items-center">
    <div class="col-md-5 col-12 order-2 order-md-1 p-md-5 py-3 px-sm-5 px-1">
      <h3 class="text-center text-rojo font-weight-bold px-4 pt-2 pb-0 title">Fácil y Simple</h3>
      <hr class="hr-1">
      <p class="subtitle lh-sm text-justify">Permite el control visual de la ocupación de las mesas, puedes gestionar
        tus órdenes a cocina, generar comprobantes electrónicos de ventas y mucho más .</p>
    </div>
    <div class="col-md-7 order-1 order-md-2 col-12 text-center p-md-3 px-0">
      <img src="../../assets/image/galeria/rest-1.png" class="img-fluid" alt="">
    </div>
  </div>
  <div class="row align-items-center" style="background-color: #1197B2">
    <div class="col-md-7 col-12 text-center p-3 order-md-1 order-2">
      <img src="../../assets/image/galeria/rest-2.png" class="img-fluid" alt="">
    </div>
    <div class="col-md-5 col-12 p-5 order-md-2 order-1">
      <h3 class="text-center text-rojo font-weight-bold px-4 py-2 title">Impresión en las Diferentes Áreas</h3>
      <hr>
      <p class="text-white text-justify fw-bold subtitle lh-sm">El sistema hace impresión de órdenes a cocina de los
        diferentes pedidos que se encuentran en las mesas, así
        mismo, puede tener muchos puntos de venta en diferentes áreas de su restaurante. En la cocina obtendrán una
        comanda legible, fácil de leer e interpretar para que la operación sea óptima.</p>
    </div>
  </div>
  <div class="row align-items-center mt-5" style="background-color: #E8E9F3">
    <div class="col-md-6 col-12 p-md-5 px-5 py-3 text-center">
      <h3 class="font-weight-bold p-3 title text-rojo">Rápida Implementación</h3>
      <hr>
      <p class="fw-bold text-dark subtitle lh-sm text-justify">La implementación es uno de los puntos críticos, una vez
        establecido lo que se necesita y habiendo comprobado
        las facilidades técnicas, procedemos con la instalación y configuración de equipos y software, para luego en
        cuestión de minutos poder realizar las pruebas y capacitación que dejarán funcionando el sistema el mismo día
        de la implantación, procediendo al seguimiento respectivo para que tu negocio y tus colaboradores se habitúen
        rápidamente al uso del sistema.</p>
    </div>
    <div class="col-md-6 col-12 text-center p-3">
      <img src="../../assets/image/galeria/rest-3.png" class="img-fluid" alt="">
    </div>
  </div>
  <div class="row align-items-center mt-5" style="background-color: #DDF0DD">
    <div class="col-md-6 col-12 text-center p-3 order-md-1 order-2">
      <img src="../../assets/image/galeria/rest-4.png" class="img-fluid" alt="">
    </div>
    <div class="col-md-6 col-12 p-5 order-md-2 order-1">
      <h3 class="text-center fw-bold text-rojo px-4 mb-3 title">Facturación Electrónica</h3>
      <hr>
      <p class="subtitle text-justify text-dark">Tanto si ya estás obligado por SUNAT o si deseas utilizarlo de forma
        voluntaria, puedes integrar al proceso
        de Comprobantes Electrónicos, permitiendo gestionar asi Facturas, boletas, notas de crédito, notas de débito y
        guías de remisión, además si lo necesitas puedes usar nuestra plataforma online para realizar comprobantes
        desde cualquier dispositivo que tenga acceso a internet y navegador web (PC, laptop, tablet, smartphone, etc.).
      </p>
    </div>
  </div>
</section>
<article class="container-fluid body-m">
  <div class="row mx-0 mb-5">
    <div class="col-md-8 offset-md-2 col-12 mb-5">
      <div class="row">
        <div class="col-12 text-center mb-2">
          <h2 class="fw-bold subtitle text-lago">Otros beneficios de contar con el sistema de facturación para
            restaurantes</h2>
        </div>
        <div class="col-md-6 col-12 bg-humo pt-4">
          <ul class="text text-lago fw-bold text lh-sm">
            <li>Toma de pedidos desde un dispositivo móvil (celular, Tablet, pantalla táctil).</li>
            <li>Carta digital.</li>
            <li>Gestión de inventario.</li>
            <li>Gestión de mesas/salas/ambientes.</li>
            <li>Recetario de platos (controla la cantidad de los insumos utilizados)</li>
          </ul>
        </div>
        <div class="col-md-6 col-12 bg-pantano pt-4">
          <ul class="text fw-bold text-humo lh-sm">
            <li>Punto de venta.</li>
            <li>Gestiona las operaciones desde cualquier lugar.</li>
            <li>Reportes inteligentes.</li>
            <li>Gestión de órdenes y pedidos.</li>
            <li>Comprobantes electrónicos ilimitados.</li>
          </ul>
        </div>
      </div>
    </div>
    <div class="col-12 mb-5">
      <div class="row mx-0 d-flex align-items-center">
        <div class="col-lg-7 col-md-6 col-12">
          <div class="container p-md-5 p-1">
            <h3 class="text-lago text-center title fw-bold">SISTEMA MOVIL PARA RESTAURANTES</h3>
            <p class="subtitle fw-bold text-rojo">Con el sistema móvil tomar pedidos ya no será un problema. Las
              comandas móviles le permitirán generar ordenes de pedidos directamente a cocina/barra desde un celular o
              Tablet.</p>
            <ul class="text fw-bold list-center text-rojo">
              <li>Panel de lista de pedidos, donde podrás observar todos los pedidos realizados antes de generar la
                orden en cocina/barra.</li>
              <li>Cada mozo tendrá un usuario para la atención, por lo que podrás controlar la cantidad de mesas
                atendidas por mozo.</li>
              <li>Controla el estado de los pedidos, veras si están pendientes de atención, atendidos o cancelados.</li>
              <li>El panel de mesas te permitirá diferenciar que mesas están ocupadas y que mesas están libres.</li>
              <li>Agrega observaciones a tus pedidos. ¡Algunos clientes no quieren el ceviche con picante!</li>
              <li>El sistema móvil cuenta con una carta virtual interactiva para la toma de pedidos.</li>
              <li>Podrás ver el precio de tus platos y modificar la cantidad.</li>
            </ul>
            <div class="row mt-3">
              <div class="col-md-6 col-12 px-0">
                <div class="card border-0 bg-pantano">
                  <div class="card-body">
                    <h5 class="text-center title text-naranja">INSTALACIÓN</h5>
                    <p class="text-justify text fw-bold text-humo lh-sm">Lorem ipsum dolor sit amet consectetur
                      adipisicing elit. Officia aut repudiandae labore, asperiores sint, praesentium consectetur cum
                      repellendus aperiam assumenda tempora voluptas omnis modi et, inventore corrupti pariatur alias
                      animi.</p>
                  </div>
                </div>
              </div>
              <div class="col-md-6 col-12 px-0">
                <div class="card border-0 bg-humo">
                  <div class="card-body">
                    <h5 class="text-center title text-naranja">SOPORTE</h5>
                    <p class="text-justify text text-lago lh-sm fw-bold">Lorem ipsum dolor sit amet consectetur
                      adipisicing elit. Officia aut repudiandae labore, asperiores sint, praesentium consectetur cum
                      repellendus aperiam assumenda tempora voluptas omnis modi et, inventore corrupti pariatur alias
                      animi.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-5 col-md-6 col-12 px-0">
          <div class="carousel-f"
            data-flickity='{ "bgLazyLoad": 1, "autoPlay": true, "wrapAround": false, "fullscreen": true }'>
            <img src="../../assets/image/movil/restaurante-1.jpg" class="carousel-cell" alt="">
            <img src="../../assets/image/movil/restaurante-2.jpg" class="carousel-cell" alt="">
            <img src="../../assets/image/movil/restaurante-3.jpg" class="carousel-cell" alt="">
            <img src="../../assets/image/movil/restaurante-4.jpg" class="carousel-cell" alt="">
            <img src="../../assets/image/movil/restaurante-5.jpg" class="carousel-cell" alt="">
            <img src="../../assets/image/movil/restaurante-6.jpg" class="carousel-cell" alt="">
            <!-- <div class="carousel-cell" data-flickity-bg-lazyload="https://unsplash.it/480/645/?random"></div>
            <div class="carousel-cell" data-flickity-bg-lazyload="https://unsplash.it/480/646/?random"></div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</article>
<footer-web class="mt-5"></footer-web>
